import {
  WHFeatureKeyENUM,
  WHPermissionKeyENUM,
} from '@workheld/workheld-shared-lib';
import { PlannerView } from 'src/app/app-modules-pages/planner-core/planner-core.constants';

// TODO(WHP-12988): replace with WHFeatureKeyENUM.ADVANCED_TEAM_PLANNER_V2 and
// WHPermissionKeyENUM.FLOW_COORDINATOR_TEAM_PLANNER_WRITE once the shared-lib release from
// ngx-workheld-libs branch feature/WHP-12988-team-planner-v2-keys is in. Same keys as the backend (WHP-12967).
export const TEAM_PLANNER_V2_FEATURE_KEY =
  'advancedTeamPlanner.v2.enabled' as WHFeatureKeyENUM;
export const TEAM_PLANNER_WRITE_PERMISSION_KEY =
  'flow.coordinator.team_planner.write' as WHPermissionKeyENUM;

/** Route of the classic Team Planner below the Team Planner route, reachable during the 2.0 pilot. */
export const TEAM_PLANNER_CLASSIC_PATH = 'classic';

/** Work Object / Work Order → Scheduler Pro view, Work Step → Gantt view (decision B). */
export type TeamPlannerV2View = PlannerView | 'WORK_STEP';

export const TEAM_PLANNER_V2_VIEWS: {
  view: TeamPlannerV2View;
  translateKey: string;
}[] = [
  { view: 'WORK_OBJECT', translateKey: 'workobject.model.root' },
  { view: 'WORK_ORDER', translateKey: 'workorder.model.root' },
  { view: 'WORK_STEP', translateKey: 'workstep.model.root' },
];
